/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nobusinessesyet2Inputs */

const en_nobusinessesyet2 = /** @type {(inputs: Nobusinessesyet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No businesses yet`)
};

const de_nobusinessesyet2 = /** @type {(inputs: Nobusinessesyet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Unternehmen`)
};

/**
* | output |
* | --- |
* | "No businesses yet" |
*
* @param {Nobusinessesyet2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nobusinessesyet2 = /** @type {((inputs?: Nobusinessesyet2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nobusinessesyet2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nobusinessesyet2(inputs)
	return de_nobusinessesyet2(inputs)
});
export { nobusinessesyet2 as "noBusinessesYet" }